import DeleteSafetyAnchorPointRequestModelBase from '../_generated/modelBases/delete-safety-anchor-point-request-model-base';

export default class DeleteSafetyAnchorPointRequestModel extends DeleteSafetyAnchorPointRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
